import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, useMediaQuery, useTheme, Tooltip } from '@mui/material';
import useFloatingActionButtonStyles from './useFloatingButtonStyles';
const FloatingActionButton = ({ onClick, buttonText, children, startIcon, endIcon, additionalButton, cancelButton, bg = 'blue', primaryBtnType = 'button', disabled = false, floating = true, sx }) => {
    const styles = useFloatingActionButtonStyles();
    const theme = useTheme();
    const isIpadScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('xl'));
    const containerStyles = floating
        ? {
            ...styles.floatingContainer
        }
        : {
            // Non-floating styles - absolute to bottom of relative parent
            padding: isSmallScreen ? '12px 0' : '0',
            position: 'absolute',
            bottom: '-10px',
            left: 0,
            right: 0,
            zIndex: 10,
            display: 'flex',
            flexDirection: isSmallScreen ? 'column' : 'row',
            justifyContent: isSmallScreen ? 'center' : 'space-between',
            alignItems: 'center',
            gap: isSmallScreen ? '12px' : '16px',
            paddingLeft: isSmallScreen ? '12px' : '16px',
            paddingRight: isSmallScreen ? '12px' : '16px'
        };
    return (_jsxs(Box, { sx: [containerStyles, ...(Array.isArray(sx) ? sx : [sx])], children: [!isSmallScreen && (_jsxs(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    backgroundColor: 'white',
                    width: '100%'
                }, children: [_jsx(Box, { sx: { display: 'flex', alignItems: 'center' }, children: additionalButton }), _jsxs(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '16px'
                        }, children: [cancelButton, _jsx(Tooltip, { title: buttonText, arrow: true, children: _jsx(Button, { sx: {
                                        ...styles.button,
                                        ...(floating
                                            ? {}
                                            : {
                                                fontSize: 'clamp(14px, 2vw, 16px)',
                                                fontWeight: 500,
                                                textTransform: 'none',
                                                minWidth: '140px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }),
                                        '&.Mui-disabled': {
                                            backgroundColor: '#939393',
                                            color: theme.palette.common.white,
                                            opacity: 0.75
                                        }
                                    }, variant: floating ? 'contained' : 'contained', color: floating ? 'primary' : 'primary', size: 'large', startIcon: startIcon, endIcon: endIcon, onClick: onClick, type: primaryBtnType, disabled: disabled, children: buttonText }) })] })] })), isSmallScreen && (_jsxs(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                    width: '100%'
                }, children: [_jsx(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }, children: additionalButton }), _jsxs(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '16px'
                        }, children: [cancelButton, _jsx(Tooltip, { title: buttonText, arrow: true, children: _jsx(Button, { sx: {
                                        ...styles.button,
                                        ...(floating
                                            ? {}
                                            : {
                                                borderRadius: '20px',
                                                padding: '8px 16px',
                                                fontSize: 'clamp(12px, 2.5vw, 14px)',
                                                fontWeight: 500,
                                                textTransform: 'none',
                                                minWidth: '120px',
                                                maxWidth: '200px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }),
                                        '&.Mui-disabled': {
                                            backgroundColor: '#939393',
                                            color: theme.palette.common.white,
                                            opacity: 0.75
                                        }
                                    }, variant: floating
                                        ? isSmallScreen || isIpadScreen
                                            ? 'outlined'
                                            : 'contained'
                                        : 'contained', color: floating ? 'primary' : 'primary', size: 'large', fullWidth: floating, startIcon: startIcon, endIcon: endIcon, onClick: onClick, type: primaryBtnType, disabled: disabled, children: buttonText }) })] })] })), children] }));
};
export default FloatingActionButton;
